import { DocsItem } from "@academy/components"

const link = (href: string, link: string) =>
  `<a href="${href}" class="underline text-blue-600" target="_blank">${link}</a>`

export const POLICY_STATIC: DocsItem[] = [
  {
    title: "",
    content: [
      {
        html: `These User Agreement and Terms of Use (the “<strong>Terms</strong>”) govern your use of the websites and services operated by <strong>Ed Technologies Corp.</strong> (“<strong>Ed Technologies</strong>,” “<strong>we</strong>,” “<strong>us</strong>,” or “<strong>our</strong>”) and, where applicable, its <strong>affiliated companies and entities</strong>, including:`,
      },
      {
        html: `<ul class="list-inside list-disc mb-[1rem]">
          <li class="docs__item mb-[1rem]"><strong>KidEntrepreneurs.academy or Kidpreneurs.academy</strong>, which provides educational classes and programs;</li>
          <li class="docs__item mb-[1rem]"><strong>KidsCrafts.shop</strong>, an educational marketplace where children, with parental or guardian consent and supervision, can learn business skills and create product listings;</li>
          <li class="docs__item mb-[1rem]"><strong>OnlineSafetyReadiness.com</strong>, which provides online safety education, training, assessments, and recommendations to individuals, schools, and educational organizations; and</li>
          <li class="docs__item"><strong>AfterSchoolVote.com</strong>, a website that allows parents and guardians to express their preferences and vote on educational courses or programs they would like to see offered at their children's schools.</li>
        </ul>`,
      },
      {
        html: `These websites and services are collectively referred to as the “<strong>Services</strong>.”`,
      },
    ],
  },
  {
    title: "1. Information We Collect",
    content: [
      {
        html: `Depending on how you use our Services, we may collect:`,
      },
    ],
  },
  {
    title: "Parents, guardians, and adult users:",
    content: [
      {
        list: {
          description: "",
          items: [
            "Name and Last Name;",
            "Email address;",
            "Phone number;",
            "Mailing or billing address;",
            "Account information;",
            "Information submitted through forms or communications; and",
            "Information needed to process purchases or provide our Services.",
          ],
        },
      },
    ],
  },
  {
    title: "Children and students:",
    content: [
      {
        html: `<ul class="list-inside list-disc mb-[1rem]">
          <li class="docs__item mb-[1rem]">On KidEntrepreneurs.academy, OnlineSafetyReadiness.com and KidsCrafts.shop: during the purchase process, we collect the first names of the child(ren) who will be attending the purchased classes.</li>
          <li class="docs__item"><span>On KidsCrafts.shop: to create an account, we collect information provided by the parent/guardian, which may include:</span>
            <ul class="list-inside list-disc mb-[1rem] ml-[1rem] mt-[0.5rem]">
              <li class="docs__item">A username;</li>
              <li class="docs__item">A store name which should not contain the child's name;</li>
              <li class="docs__item"><strong>User-Generated Content:</strong> product listings, images, descriptions, parameters, and prices submitted through the platform's monitored systems; and</li>
              <li class="docs__item"><strong>Transaction Data:</strong> details of sales, purchases, and, if applicable, shipping addresses used for order fulfillment.</li>
            </ul>
          </li>
        </ul>`,
      },
    ],
  },
  {
    title: "AfterSchoolVote.com:",
    content: [
      {
        html: `AfterSchoolVote.com may collect information needed to administer a parent or guardian preference survey, such as an email address, school or district affiliation, voting status, and the selected preferences. We may use this information to prevent duplicate submissions, verify eligibility where applicable, analyze interest in proposed programs, and provide aggregated results to participating schools or organizations. Individual responses will not be publicly displayed. We may publish or share aggregated results that are not reasonably linked to an identifiable parent or guardian.`,
      },
    ],
  },
  {
    title: "Automatically collected information:",
    content: [
      {
        html: `We may automatically collect IP address, browser and device information, pages visited, usage and diagnostic information, and similar technical data.`,
      },
    ],
  },
  {
    title: "2. Cookies",
    content: [
      {
        html: `We use cookies and similar technologies to operate our Services, maintain security, understand website usage, remember preferences, and improve our platforms.`,
      },
      {
        html: `You can control cookies through your browser settings. Where required by law, we will request consent before using non-essential cookies.`,
      },
    ],
  },
  {
    title: "3. How We Use Information",
    content: [
      {
        html: `<p class="mb-[1rem]">We use the information we collect for the following purposes:</p>
        <ul class="list-inside list-disc mb-[1rem]">
          <li class="docs__item mb-[1rem]"><strong>To Fulfill Your Requests:</strong> To process class registrations and purchases, manage accounts, operate the KidsCrafts.shop marketplace, administer AfterSchoolVote.com voting, and provide our educational Services.</li>
          <li class="docs__item mb-[1rem]"><strong>To Communicate with You:</strong> To send transactional and service-related communications, respond to inquiries, and, with your consent where required, provide information about programs and opportunities.</li>
          <li class="docs__item mb-[1rem]"><strong>For Safety and Moderation:</strong> To monitor and moderate marketplace activity, review user-generated content and transactions, and maintain a safe and appropriate environment for our users.</li>
          <li class="docs__item mb-[1rem]"><strong>To Improve Our Services:</strong> To analyze website and platform usage, understand parent preferences, and improve our educational programs, assessments, websites, and user experience.</li>
          <li class="docs__item"><strong>For Security and Compliance:</strong> To protect the safety and security of our Services, prevent fraud or unauthorized activity, and comply with applicable legal obligations.</li>
        </ul>`,
      },
    ],
  },
  {
    title: "4. Legal Basis for Processing",
    content: [
      {
        html: `<p class="mb-[1rem]">Depending on the applicable jurisdiction, we may process personal information based on:</p>
        <ul class="list-inside list-disc mb-[1rem]">
          <li class="docs__item mb-[1rem]"><strong>Contract:</strong> when processing is necessary to provide requested Services or fulfill an agreement;</li>
          <li class="docs__item mb-[1rem]"><strong>Consent:</strong> where required by law;</li>
          <li class="docs__item mb-[1rem]"><strong>Legitimate interests:</strong> such as improving Services, maintaining security, preventing abuse, and protecting users; and</li>
          <li class="docs__item"><strong>Legal obligations:</strong> when processing is required by applicable law.</li>
        </ul>`,
      },
    ],
  },
  {
    title: "5. Children's Privacy",
    content: [
      {
        html: `Some of our Services are designed for or used by children and students.`,
      },
      {
        html: `We seek to collect only information reasonably necessary to provide the applicable educational Service. We do not sell children's personal information or knowingly use it for behavioral or targeted advertising.`,
      },
      {
        html: `For KidsCrafts.shop, a parent or legal guardian must create or manage the child's account and provide consent where required. We may use reasonable measures to verify parental consent where required by law.`,
      },
      {
        html: `AfterSchoolVote.com is designed for parents and guardians. Children are not intended to create accounts or submit votes.`,
      },
      {
        html: `Where applicable, we take reasonable steps to comply with the <strong>Children's Online Privacy Protection Act (COPPA)</strong> and applicable Canadian privacy laws.`,
      },
      {
        html: `Parents and guardians may contact us to request access to, correction or deletion of their child's information, or to withdraw consent, subject to applicable law.`,
      },
    ],
  },
  {
    title: "6. School and Student Information",
    content: [
      {
        html: `When our Services are provided through a school, school district, or other educational organization, we may process student information on behalf of that organization.`,
      },
      {
        html: `Where applicable, Ed Technologies may act as a service provider or “school official” and process student information only for authorized educational purposes.`,
      },
      {
        html: `We intend to handle applicable student information in accordance with <strong>FERPA</strong> and other applicable student privacy laws.`,
      },
      {
        html: `Requests concerning educational records may need to be directed to the relevant school or district.`,
      },
    ],
  },
  {
    title: "7. Canadian Privacy Laws",
    content: [
      {
        html: `For Canadian users, we comply with applicable Canadian privacy legislation, including <strong>PIPEDA</strong> and, where applicable, the <strong>Personal Information Protection Act (PIPA) of British Columbia</strong>.`,
      },
      {
        html: `We collect, use, and disclose personal information for reasonable purposes related to providing our Services, maintaining security, improving our platforms, administering programs and voting activities, and complying with legal obligations.`,
      },
      {
        html: `Subject to applicable law, individuals may request access to or correction of their personal information.`,
      },
    ],
  },
  {
    title: "8. Artificial Intelligence",
    content: [
      {
        html: `Some Services, including OnlineSafetyReadiness.com, use AI-assisted technologies to analyze assessments and provide educational insights or recommendations.`,
      },
      {
        html: `AI-generated recommendations are intended to support learning and do not replace the judgment of parents, educators, or qualified professionals.`,
      },
      {
        html: `We do not knowingly use children's personal information to train general-purpose AI models for unrelated purposes.`,
      },
    ],
  },
  {
    title: "9. Sharing Information",
    content: [
      {
        html: `We do not sell or rent personal information.`,
      },
      {
        html: `<p class="mb-[1rem]">We may share information with:</p>
        <ul class="list-inside list-disc mb-[1rem]">
          <li class="docs__item mb-[1rem]"><strong>Service providers</strong> that help us operate our Services, including hosting, payment processing, security, analytics, communications, and technical providers;</li>
          <li class="docs__item mb-[1rem]"><strong>Schools, districts, educators, parents, guardians, or authorized organizations</strong>, where appropriate;</li>
          <li class="docs__item mb-[1rem]"><strong>Government authorities or other parties</strong>, when required or permitted by law or necessary to protect our users, Services, or legal rights;</li>
          <li class="docs__item mb-[1rem]"><strong>Business transaction parties</strong>, in connection with a merger, acquisition, restructuring, financing, or sale of assets; and</li>
          <li class="docs__item"><strong>Our other Services</strong>, where reasonably necessary to provide Services, support users, maintain security, or improve our platforms.</li>
        </ul>`,
      },
      {
        html: `Service providers are expected to use personal information only as necessary to provide services to us and in accordance with applicable contractual or legal requirements.`,
      },
    ],
  },
  {
    title: "KidsCrafts.shop Public Content",
    content: [
      {
        html: `Approved product listings and related marketplace content may be visible to other users or the public when necessary to operate KidsCrafts.shop.`,
      },
      {
        html: `Such content may include product images, descriptions, prices, and store information.`,
      },
      {
        html: `Parents and guardians should ensure that children do not include their full name, address, phone number, email address, school name, or other unnecessary personal information in publicly visible content.`,
      },
    ],
  },
  {
    title: "10. Photo and Video Consent",
    content: [
      {
        html: `With the consent of a parent or legal guardian, Ed Technologies Corp. may photograph and/or record children during classes, programs, events, and related activities.`,
      },
      {
        html: `Photos and videos may be used for educational, promotional, and informational purposes, including publication on our websites and social media channels.`,
      },
      {
        html: `We do not intentionally publish a child’s full name, home address, contact information, or other unnecessary personal information together with photographs or videos without additional consent.`,
      },
      {
        html: `Photo and video consent is voluntary and is not required for participation in our programs. Parents or legal guardians may withdraw their consent at any time by contacting us.`,
      },
    ],
  },
  {
    title: "11. Security and Retention",
    content: [
      {
        html: `We use reasonable technical, administrative, and organizational safeguards designed to protect personal information.`,
      },
      {
        html: `However, no electronic transmission or storage system is completely secure, and we cannot guarantee absolute security.`,
      },
      {
        html: `We retain personal information only for as long as reasonably necessary to provide our Services, administer accounts and voting activities, comply with legal or contractual obligations, resolve disputes, prevent abuse, and protect our legal rights.`,
      },
      {
        html: `When information is no longer required, we will delete, anonymize, or otherwise dispose of it in accordance with applicable law.`,
      },
    ],
  },
  {
    title: "12. International Data Transfers",
    content: [
      {
        html: `Our Services may be operated or supported from Canada, the United States, and other countries. Personal information may therefore be transferred to or accessed from jurisdictions outside your country of residence.`,
      },
      {
        html: `Where required, we will use appropriate safeguards for international transfers in accordance with applicable law.`,
      },
    ],
  },
  {
    title: "13. Your Privacy Rights",
    content: [
      {
        list: {
          description: "Depending on your location and applicable law, you may have the right to:",
          items: [
            "Access your personal information;",
            "Request a copy of your information;",
            "Correct inaccurate or incomplete information;",
            "Request deletion of your information;",
            "Object to or restrict certain processing; and",
            "Withdraw consent where processing is based on consent.",
          ],
        },
      },
      {
        html: `Additional rights may apply under specific privacy laws.`,
      },
      {
        html: `Requests concerning student educational records may need to be made through the relevant school or district.`,
      },
    ],
  },
  {
    title: "14. Third-Party Websites",
    content: [
      {
        html: `Our Services may contain links to third-party websites or services. We are not responsible for their privacy practices and encourage you to review their privacy policies before providing personal information.`,
      },
    ],
  },
  {
    title: "15. Changes to This Privacy Policy",
    content: [
      {
        html: `We may update this Privacy Policy from time to time.`,
      },
      {
        html: `Any changes will be posted on our Sites. We encourage you to review this Privacy Policy periodically.`,
      },
    ],
  },
  {
    title: "16. Contact Us",
    content: [
      {
        html: `If you have questions about this Privacy Policy, your personal information, your child's information, or wish to exercise an applicable privacy right or withdraw consent, please contact us:`,
      },
      {
        html: `<strong>Attn: Privacy Officer</strong><br />
        Email: <a class="underline text-primary" href="mailto:service@KidEntrepreneurs.academy">service@KidEntrepreneurs.academy</a>`,
      },
    ],
  },
]
